import { API } from '@unboared/react';

import {
    CastVotePayload,
    FP_ACTION_CAST_VOTE,
    FP_ACTION_REQUEST_CHANGE,
    FP_ACTION_REQUEST_START,
    RequestChangePayload,
    RequestStartPayload,
    VoteChoice,
} from './types';

/**
 * Gamepad → host: ask to start a game from idle.
 */
export function requestStartGame(gameID: string): void {
    const payload: RequestStartPayload = { gameID };
    API.emitAction(FP_ACTION_REQUEST_START, payload);
}

/**
 * Gamepad → host: propose to switch the running game (triggers a vote).
 */
export function requestChangeGame(gameID: string): void {
    const payload: RequestChangePayload = { gameID };
    API.emitAction(FP_ACTION_REQUEST_CHANGE, payload);
}

/**
 * Gamepad → host: cast a yes/no vote.
 */
export function castVote(vote: VoteChoice): void {
    const payload: CastVotePayload = { vote };
    API.emitAction(FP_ACTION_CAST_VOTE, payload);
}
